
import Navbar from '../home/components/Navbar';
import Contact from '../home/components/Contact';
import Footer from '../home/components/Footer';
import FloatingWhatsApp from '../home/components/FloatingWhatsApp';
import { useState, useEffect } from 'react';

export default function ContatoPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <div className="pt-24">
        <Contact />
      </div>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
